"use strict";

var _toConsumableArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var type_1 = require("./type");

var stackReducer = function stackReducer(state, action) {
  if (action.type === type_1.ActionType.SHOW_ADD_FORM) {
    return Object.assign(Object.assign({}, state), {
      showAdd: true
    });
  }

  if (action.type === type_1.ActionType.HIDE_ADD_FORM) {
    return Object.assign(Object.assign({}, state), {
      showAdd: false
    });
  }

  if (action.type === type_1.ActionType.SELECT_ROW) {
    if (action.payload === undefined || state.selectedIds.includes(action.payload)) {
      return state;
    }

    return Object.assign(Object.assign({}, state), {
      selectedIds: [].concat(_toConsumableArray(state.selectedIds), [action.payload])
    });
  }

  if (action.type === type_1.ActionType.REMOVE_DETAIL) {
    return Object.assign(Object.assign({}, state), {
      selectedIds: state.selectedIds.filter(function (id) {
        return id !== action.payload;
      })
    });
  }

  if (action.type === type_1.ActionType.DELETE_ITEM) {
    return Object.assign(Object.assign({}, state), {
      selectedIds: state.selectedIds.filter(function (id) {
        return id !== action.payload;
      })
    });
  }

  return state;
};

exports.default = stackReducer;